import { useQuery } from "@tanstack/react-query";

import { telemetryAjax } from "../../ajax/TelemetryAjax";
import { ErrorResponse } from "../../DTOs/Common/ErrorResponse";
import { DrillBlastMapOverlayDTO } from "../../DTOs/Telemetry/DrillBlastMapOverlayDTO";

export const DRILL_BLAST_OVERLAY_QUERY_KEY = ["telemetry", "drillBlastOverlay"];

// Note: refetched every minute while the layer is on, because a misfire reported on the bench should reach the map
// without anyone reloading it.
export function useDrillBlastOverlay(enabled: boolean): DrillBlastMapOverlayDTO | null {
  const { data = null } = useQuery({
    queryKey: DRILL_BLAST_OVERLAY_QUERY_KEY,
    enabled,
    queryFn: async () => {
      const res = await telemetryAjax.getDrillBlastOverlay();
      if (ErrorResponse.isErrorResponse(res)) return null;
      return res;
    },
    refetchInterval: 60 * 1000,
  });

  return data;
}
